import { render, staticRenderFns } from "./review-headline.vue?vue&type=template&id=4b2bf594&"
import script from "./review-headline.vue?vue&type=script&lang=js&"
export * from "./review-headline.vue?vue&type=script&lang=js&"
import style0 from "./review-headline.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "review-headline.vue"
export default component.exports